import * as moment from 'moment';
import 'moment-duration-format';

export function secondsToString(num) {
  const s = moment.duration(num, 'seconds').format('hh:mm:ss.SS', { trim: false });
  return s;
}
